var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasicChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 511.141 511.141",
    height: 512,
    viewBox: "0 0 511.141 511.141",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m93.194 466.626h-20.002c-8.284 0-15-6.716-15-15s6.716-15 15-15h20.002c8.284 0 15 6.716 15 15s-6.715 15-15 15z",
    fill: "#4bb6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.383 466.626h-20.002c-8.284 0-15-6.716-15-15s6.716-15 15-15h20.002c8.284 0 15 6.716 15 15s-6.716 15-15 15z",
    fill: "#4bb6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m351.718 467.333h-20.002c-8.284 0-15-6.716-15-15s6.716-15 15-15h20.002c8.284 0 15 6.716 15 15s-6.716 15-15 15z",
    fill: "#398ce9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.948 466.625h-20.002c-8.284 0-15-6.716-15-15s6.716-15 15-15h20.002c8.284 0 15 6.716 15 15s-6.716 15-15 15z",
    fill: "#398ce9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.571 466.626h-20.002c-8.284 0-15-6.716-15-15s6.716-15 15-15h20.002c8.284 0 15 6.716 15 15s-6.716 15-15 15z",
    fill: "#4bb6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.571 436.626h-10.001v30h10.001c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
    fill: "#398ce9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m283.664 204.206h-56.188c-8.284 0-15 6.716-15 15l-10.001 162.415c0 8.284 6.716 15 15 15h76.189c8.284 0 15-6.716 15-15l-10.001-162.415c.001-8.284-6.715-15-14.999-15z",
    fill: "#5f77af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.664 219.206c0-8.284-6.716-15-15-15h-28.094v192.415h38.095c8.284 0 15-6.716 15-15z",
    fill: "#455da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.287 204.206h-56.187c-8.284 0-15 6.716-15 15v162.415c0 8.284 6.716 15 15 15h66.188c8.285 0 15-6.716 15-15l-10-162.415c-.001-8.284-6.717-15-15.001-15z",
    fill: "#5f77af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m197.477 150.74h-56.189c-8.284 0-15 6.716-15 15v215.881c0 8.284 6.716 15 15 15h56.189c8.284 0 15-6.716 15-15v-215.881c0-8.284-6.716-15-15-15z",
    fill: "#ffda2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m369.853 110.64h-56.188c-8.284 0-15 6.715-15 15v255.98c0 8.284 6.716 15 15 15h66.189c8.283 0 15-6.716 15-15l-10.001-255.98c0-8.284-6.716-15-15-15z",
    fill: "#febf01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m456.041 43.807h-56.188c-8.284 0-15 6.715-15 15v322.813c0 8.284 6.716 15 15 15h56.188c8.284 0 15-6.716 15-15v-322.813c0-8.284-6.716-15-15-15z",
    fill: "#a6d12d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496.141 406.621h-481.141c-8.284 0-15-6.716-15-15s6.716-15 15-15h481.141c8.284 0 15 6.716 15 15s-6.716 15-15 15z",
    fill: "#4bb6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496.141 376.621h-240.571v30h240.57c8.284 0 15-6.716 15-15 .001-8.284-6.715-15-14.999-15z",
    fill: "#398ce9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicChart);
export default __webpack_public_path__ + "static/media/basicChart.ac20690ddb1d6cd9f5ac2734e200ca49.svg";
export { ForwardRef as ReactComponent };